export const CP_FIELD_NAME = 'cp';
export const COLONIA_FIELD_NAME = 'colonia';
export const ALLOWED_CPS_FIELDS_NAMES = [CP_FIELD_NAME];
export const EMPLOYEE_TYPE_FIELD_NAME = 'employeeType';
export const SUELDO_MENSUAL_FIELD_NAME = 'sueldo';
export const INGRESOS_TOTALES_COACREDITADO_FIELD_NAME = 'ingresosTotalesCoacreditado';
